"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = BranchCircle;

var _BranchCircle = require("@adobe/react-spectrum-workflow/dist/BranchCircle");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function BranchCircle(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_BranchCircle.A4uBranchCircle, null));
}